module.exports = __webpack_public_path__ + "img/SEJ enventos_mensaje.fc2a17c2.svg";